export const DEV_CONSOLE_API_BASE_URL = '/api';

export const DEV_CONSOLE_MAX_AUTH_REDIRECTS = 3;
export const DEV_CONSOLE_AUTH_REDIRECT_WINDOW_MS = 60_000;

export const DEV_CONSOLE_AXIOM_QUERY_BASE_URL = 'https://app.axiom.co/nourish-ttys/query';
export const DEV_CONSOLE_AXIOM_WORKER_LOGS_DATASET = 'worker-logs';

export const DEV_CONSOLE_VISIT_HISTORY_STORAGE_KEY = 'devConsole:visitHistory';
export const DEV_CONSOLE_VISIT_HISTORY_MAX_ENTRIES = 50;
